import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-multi-select-checkbox',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './multi-select-checkbox.component.html',
  styleUrls: ['./multi-select-checkbox.component.css']
})
export class MultiSelectCheckboxComponent {

  @Input() list: any[] = [];

  @Output() shareCheckedList = new EventEmitter<string[]>();

  showDropDown = false;

  // 🔥 SINGLE SOURCE OF TRUTH (no extra checkedList)

  toggleDropdown() {
    this.showDropDown = !this.showDropDown;
  }

  onChange() {
    const selected = this.list
      .filter(x => x.checked)
      .map(x => x.name);

    this.shareCheckedList.emit(selected);
  }

  getSelectedText(): string {
    const selected = this.list
      .filter(x => x.checked)
      .map(x => x.name);

    return selected.length ? selected.join(', ') : 'Select';
  }
}
